import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatCardModule} from '@angular/material/card';
import {MatIconModule} from '@angular/material/icon';
import {MatRippleModule} from '@angular/material/core';
import {AppointmentTypeOption} from '../../appointments/model/appointments-models';

@Component({
  selector: 'app-appointment-type-card',
  standalone: true,
  imports: [CommonModule, MatCardModule, MatIconModule, MatRippleModule],
  templateUrl: './appointment-type-card.component.html',
  styleUrls: ['./appointment-type-card.component.scss']
})
export class AppointmentTypeCardComponent {
  @Input() type!: AppointmentTypeOption;
  @Input() selected = false;
  @Output() selectType = new EventEmitter<AppointmentTypeOption>();

  onSelect() {
    this.selectType.emit(this.type);
  }
}
